jQuery(document).ready(function ($) {
    function toggleHeaderScroll() {
        const threshold = $('body').hasClass('dark-header') ? 0 : 200;

        if ($(window).scrollTop() > threshold) {
            $('body').addClass('on-scroll');
        } else {
            $('body').removeClass('on-scroll');
        }
    }

    $(window).on('scroll', function (event) {
        toggleHeaderScroll();
    });

    toggleHeaderScroll();
});